
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team-member/[slug]",
      function () {
        return require("private-next-pages/team-member/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team-member/[slug]"])
      });
    }
  